"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _PassengerSelectionStepper = _interopRequireDefault(require("../PassengerSelectionStepper"));

var _passengerRoomSelectionExpander = _interopRequireDefault(require("./passengerRoomSelectionExpander.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var PassengerRoomSelectionExpanderWrapper = _styledComponents.default.div.withConfig({
  displayName: "PassengerRoomSelectionExpander__PassengerRoomSelectionExpanderWrapper",
  componentId: "sc-1i6nrc3-0"
})(["border:1px solid ", ";border-radius:", ";padding:", ";background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors[_constant.DEFAULT_STYLE.BORDER_COLOR];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius.small;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "0 ".concat(theme.space.small);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.backgroundColor.default;
});

var RemoveButton = _styledComponents.default.div.withConfig({
  displayName: "PassengerRoomSelectionExpander__RemoveButton",
  componentId: "sc-1i6nrc3-1"
})([""]);

var SelectionExpanderWrapper = _styledComponents.default.div.withConfig({
  displayName: "PassengerRoomSelectionExpander__SelectionExpanderWrapper",
  componentId: "sc-1i6nrc3-2"
})(["display:flex;align-items:center;justify-content:space-between;min-height:56px;position:relative;cursor:pointer;", " ", "{pointer-events:all;cursor:pointer;}"], function (_ref5) {
  var expand = _ref5.expand,
      enableToggle = _ref5.enableToggle;
  return expand && !enableToggle && "pointer-events: none;\n    cursor: not-allowed !important;";
}, RemoveButton);

var LabelContainer = _styledComponents.default.div.withConfig({
  displayName: "PassengerRoomSelectionExpander__LabelContainer",
  componentId: "sc-1i6nrc3-3"
})(["display:flex;flex-direction:column;"]);

var Separator = _styledComponents.default.div.withConfig({
  displayName: "PassengerRoomSelectionExpander__Separator",
  componentId: "sc-1i6nrc3-4"
})(["border-bottom:1px solid ", ";border-opacity:", ";margin-bottom:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors[_constant.DEFAULT_STYLE.BORDER_COLOR];
}, _constant.DEFAULT_STYLE.BORDER_OPACITY, function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.space.small);
});

var PassengerRoomSelectionExpander = function PassengerRoomSelectionExpander(props) {
  var expanderTitle = props.expanderTitle,
      data = props.data,
      expand = props.expand,
      enableToggle = props.enableToggle,
      showRemove = props.showRemove,
      onRemove = props.onRemove,
      handleClick = props.handleClick,
      onChangeData = props.onChangeData,
      changeChildAge = props.changeChildAge,
      theme = props.theme,
      accessible = props.accessible,
      isShowChildAgeInput = props.isShowChildAgeInput,
      device = props.device,
      isShowInfantSelect = props.isShowInfantSelect,
      enablePaxAgeUpdate = props.enablePaxAgeUpdate;

  var _ref8 = data || {},
      labels = _ref8.labels,
      adult = _ref8.adult,
      child = _ref8.child,
      infant = _ref8.infant,
      minPassengers = _ref8.minPassengers,
      maxPassengers = _ref8.maxPassengers,
      passengerCount = _ref8.passengerCount,
      stepperConfig = _ref8.stepperConfig,
      childList = _ref8.childList,
      ageList = _ref8.ageList;

  var _useState = (0, _react.useState)(expand),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      select = _useState2[0],
      setSelect = _useState2[1];

  var _useState3 = (0, _react.useState)(passengerCount),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      pax = _useState4[0],
      setPax = _useState4[1];

  var _useState5 = (0, _react.useState)(childList !== null && childList !== void 0 ? childList : null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      paxChild = _useState6[0],
      setPaxChild = _useState6[1];

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  /**
   * if enableToggle prop is true, Expander expands or shrinks on click
   * if enableToggle prop is false, custom handle click function will be invoked on Expander click
   */

  var handleOnclick = function handleOnclick() {
    if (enableToggle) setSelect(!select);
    if (handleClick && !enableToggle) handleClick();
  };
  /**
   * @param {object} paxCount
   * call back that receives the passenger count of each passenger types from PassengerSelectionStepper component
   * Example: paxCount = {
   *    adult: 2,
   *    child: 1,
   *    infant: 0
   * }
   */


  var handleOnChangeData = function handleOnChangeData(paxCount) {
    if (onChangeData) onChangeData(paxCount);
    setPax(_objectSpread(_objectSpread({}, pax), paxCount));
  };
  /**
   * @param {object} pax
   * call back that receives the child age list of each child types from PassengerSelectionStepper component
   * Example: pax = [{label: 2, value: 2}, {label: 4, value: 4}]
   */


  var handleOnChangeChildList = function handleOnChangeChildList(paxData) {
    if (isShowChildAgeInput) {
      if (changeChildAge) changeChildAge(paxData);
      setPaxChild(paxData);
    }
  };
  /**
   * Constructs the sub label to display the passenger count and passenger type.
   *  To display the sub label in singular or plural form depending upon the passenger count
   */


  var constructSubLabel = function constructSubLabel() {
    var constructedSubLabel = '';

    if (pax != null) {
      Object.keys(pax).forEach(function (paxType) {
        if (pax[paxType] === 1) constructedSubLabel = constructedSubLabel.concat("".concat(pax[paxType], " ").concat(labels["".concat(paxType, "Single")], ", "));else if (pax[paxType] > 1) {
          constructedSubLabel = constructedSubLabel.concat("".concat(pax[paxType], " ").concat(labels["".concat(paxType, "Plural")], ", "));
        }
      });
      return constructedSubLabel.slice(0, -2);
    }

    return null;
  };

  var renderLabel = function renderLabel() {
    return /*#__PURE__*/_react.default.createElement(LabelContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      bold: true,
      display: _constant.DEFAULT_STYLE.LABEL.DISPLAY,
      theme: theme,
      type: _constant.DEFAULT_STYLE.LABEL.TYPE,
      customProperties: {
        id: 'selection-expander-label'
      }
    }, expanderTitle), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      color: _constant.DEFAULT_STYLE.SUB_LABEL.COLOR,
      customProperties: {
        id: 'selection-expander-subLabel'
      },
      display: _constant.DEFAULT_STYLE.SUB_LABEL.DISPLAY,
      theme: theme,
      type: _constant.DEFAULT_STYLE.SUB_LABEL.type
    }, constructSubLabel()));
  };

  var renderPassengerSelectionStepper = function renderPassengerSelectionStepper() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Separator, null), /*#__PURE__*/_react.default.createElement(_PassengerSelectionStepper.default, {
      data: {
        placeholder: labels,
        adult: adult,
        child: child,
        infant: infant,
        passengerCount: passengerCount,
        min: minPassengers,
        max: maxPassengers,
        stepperConfig: stepperConfig,
        passengerChildAge: paxChild,
        ageList: ageList
      },
      device: device,
      stepperClicked: handleOnChangeData,
      setPaxChild: handleOnChangeChildList,
      isShowChildAgeInput: isShowChildAgeInput,
      isShowInfantSelect: isShowInfantSelect,
      enablePaxAgeUpdate: enablePaxAgeUpdate
    }));
  };

  var activeColor = {
    true: 'tertiaryRed',
    false: _constant.DEFAULT_STYLE.REMOVE_BUTTON.COLOR
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(PassengerRoomSelectionExpanderWrapper, {
      theme: themeContext,
      tabIndex: tabIndex
    }, /*#__PURE__*/_react.default.createElement(SelectionExpanderWrapper, {
      theme: themeContext,
      onClick: handleOnclick,
      expand: expand,
      enableToggle: enableToggle
    }, renderLabel(), showRemove && /*#__PURE__*/_react.default.createElement(RemoveButton, {
      onClick: onRemove,
      "data-test": "remove-button"
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      display: "inlineFlex",
      theme: theme,
      type: _constant.DEFAULT_STYLE.REMOVE_BUTTON.TYPE,
      color: activeColor[theme === 'AIRASIA_MOVE' || (themeContext === null || themeContext === void 0 ? void 0 : themeContext.type) === 'AIRASIA_MOVE']
    }, labels.roomRemoveButton))), enableToggle ? select && renderPassengerSelectionStepper() : expand && renderPassengerSelectionStepper());
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

PassengerRoomSelectionExpander.propTypes = _passengerRoomSelectionExpander.default.PropTypes;
PassengerRoomSelectionExpander.defaultProps = _passengerRoomSelectionExpander.default.DefaultProps;
var _default = PassengerRoomSelectionExpander;
exports.default = _default;